import { Typography } from '@mui/material'
import ThoughtStep from './thoughtchain/ThoughtStep'
import TaskChecklist from './thoughtchain/TaskChecklist'
import TaskRow from './TaskRow'
import WorkSection from './WorkSection'

export default function TaskSection({
  title,
  caption,
  tasks,
  streaming,
  checklist = false,
}) {
  if (checklist) {
    return (
      <ThoughtStep category="plan" title={title} streaming={streaming}>
        {caption ? (
          <Typography sx={{ fontSize: 'var(--app-thought-font-size)', color: 'var(--app-text-tertiary)' }}>
            {caption}
          </Typography>
        ) : null}
        <TaskChecklist tasks={tasks} />
      </ThoughtStep>
    )
  }
  return (
    <WorkSection title={title} caption={caption}>
      {tasks.map((task) => (
        <TaskRow key={task.id} task={task} streaming={streaming} />
      ))}
    </WorkSection>
  )
}
